import {
  Flex, Input, InputGroup, InputLeftElement, InputProps, Text,
} from '@chakra-ui/react';
import React, {
  ForwardRefRenderFunction, ReactNode, forwardRef,
} from 'react';

interface TextInputProps extends InputProps {
  icon?: ReactNode,
}

const TextInput: ForwardRefRenderFunction<HTMLInputElement, TextInputProps> = (
  {
    children,
    icon,
    ...rest
  },
  ref,
) => (
  <Flex
    w="full"
    direction="column"
    gap="2"
  >
    <Text
      w="full"
      fontWeight="bold"
    >
      {children}
    </Text>
    <InputGroup>
      {icon && (
        <InputLeftElement
          pointerEvents="none"
        >
          {icon}
        </InputLeftElement>
      )}
      <Input
        {...rest}
        ref={ref}
      />
    </InputGroup>
  </Flex>
);

export default forwardRef<HTMLInputElement, TextInputProps>(TextInput);
